import { onMounted, onUnmounted } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useInterval(callback: any, time = 1000) {
  let timer: NodeJS.Timeout | null = null

  function start() {
    stop()
    timer = setInterval(callback, time)
  }

  function stop() {
    if (timer !== null) {
      clearInterval(timer)
      timer = null
    }
  }

  onMounted(start)
  onUnmounted(stop)

  return { start, stop }
}
